/* Copyright 2013 - 2024 Waiterio LLC */
/* eslint-disable comma-dangle, quote-props, quotes */

export default [
  'ca-es',
  // "de-at",
  // "de-ch",
  'de-de',
  // "en-au",
  // "en-ca",
  // "en-gb",
  // "en-hk",
  'en-in',
  // "en-nz",
  // "en-ph",
  'en-pk',
  // "en-sg",
  // "en-us",
  // "es-ar",
  // "es-cl",
  // "es-co",
  // "es-cr",
  'es-es',
  'es-mx',
  // "es-pe",
  // "es-us",
  // "fr-be",
  // "fr-ca",
  // "fr-fr",
  // "fr-ch",
  'hu-hu',
  // "id-id",
  // "it-ch",
  'it-it',
  // "mg-my",
  // "nl-nl",
  // "nl-be",
  // "pt-br",
  // "pt-pt",
  // "ru-ru",
  // "th-th"
]
